import { ExperienciaLaboralItemForm } from "src/pages/formulario-cv/experiencia-laboral/utils";
import { TipoExperienciaEnum } from "./constantes";

export enum PerfilesId {
    EJECUTOR_TECNICO = "1e457e61-8bc2-4201-856a-8617f0705cc6",
    MENTOR = "2e457e61-8bc2-4201-856a-8617f0705cc6",
    MONITOR = "3e457e61-8bc2-4201-856a-8617f0705cc6",
    EJECUTORINGLES = "4e457e61-8bc2-4201-856a-8617f0705cc6",
    EJECUTOR_HABILIDADES_PODER = "5e457e61-8bc2-4201-856a-8617f0705cc6",
}

export const perfilData: Record<PerfilesId, { titulo: string; items: string[] }> = {
    [PerfilesId.EJECUTORINGLES]: {
        titulo: "EJECUTOR INGLÉS",
        items: [
            "Profesional en NBC: Educación, Lenguas modernas, literatura, lingüística y afines",
            "Experiencia: 3 años de experiencia en formación del idioma inglés.",
        ],
    },
    [PerfilesId.EJECUTOR_TECNICO]: {
        titulo: "EJECUTOR TÉCNICO",
        items: [
            "Profesional en NBC: Matemáticas, estadística y afines. Ingeniería de sistemas, telemática y afines o Ingeniería electrónica, telecomunicaciones y afines.",
            "Tres (3) años de experiencia, distribuidos así: Dos (2) años de experiencia como docente, monitor o instructor en alguna de las áreas de formación de la presente convocatoria (Programación, Inteligencia Artificial, Análisis de Datos, BlockChain, Arquitectura en la nube, Ciberseguridad) y un (1) año de experiencia específica en el área en el que impartirá la formación (Programación, Inteligencia Artificial, Análisis de Datos, BlockChain, Arquitectura en la nube, ciberseguridad).",
        ],
    },
    [PerfilesId.MENTOR]: {
        titulo: "MENTOR",
        items: [
            "Profesional en NBC: Matemáticas, estadística y afines. Ingeniería de sistemas, telemática y afines o Ingeniería electrónica, telecomunicaciones y afines.",
            "Tres (3) años, distribuidos así: Dos (2) años de experiencia docente o monitor o instructor, en alguna de las áreas de formación de la presente convocatoria (Programación, Inteligencia Artificial, Análisis de Datos, BlockChain, Arquitectura en la nube, Ciberseguridad) y un (1) año de experiencia específica en el área en el que impartirá la formación (Programación, Inteligencia Artificial, Análisis de Datos, BlockChain, Arquitectura en la nube, ciberseguridad)",
        ],
    },
    [PerfilesId.MONITOR]: {
        titulo: "MONITOR",
        items: [
            "Tecnólogo o Técnico o estudiante de últimos dos semestres de un programa del nivel profesional en el NBC: Matemáticas, estadística y afines. Ingeniería de sistemas, telemática y afines o Ingeniería electrónica, telecomunicaciones y afines.",
            "Seis (6) meses de experiencia como docente o monitor o instructor en Habilidades digitales.",
        ],
    },
    [PerfilesId.EJECUTOR_HABILIDADES_PODER]: {
        titulo: "EJECUTOR HABILIDADES DE PODER",
        items: [
            "Profesional en NBC: Psicología, Sociología, Trabajo Social y afines (Formación neurolingüística).",
            "2 años de experiencia profesional relacionada en cargos como profesional psicosocial o profesional en psicología o líder o gestor de acompañamiento en procesos educativos en una institución educativa, entidad pública o empresa privada, conocimiento de las teorías y prácticas relacionadas con habilidades blandas, habilidades de poder.",
        ],
    },
};

export const ExperienciasRequeridas = {
    [PerfilesId.EJECUTOR_TECNICO]: {
        [TipoExperienciaEnum.DOCENCIA]: 24,
        [TipoExperienciaEnum.NO_DOCENCIA]: 12,
    },
    [PerfilesId.MENTOR]: {
        [TipoExperienciaEnum.DOCENCIA]: 24,
        [TipoExperienciaEnum.NO_DOCENCIA]: 12,
    },
    [PerfilesId.MONITOR]: {
        [TipoExperienciaEnum.DOCENCIA]: 6,
        [TipoExperienciaEnum.NO_DOCENCIA]: 0,
    },
    [PerfilesId.EJECUTORINGLES]: {
        [TipoExperienciaEnum.DOCENCIA]: 36,
        [TipoExperienciaEnum.NO_DOCENCIA]: 0,
    },
    [PerfilesId.EJECUTOR_HABILIDADES_PODER]: {
        [TipoExperienciaEnum.DOCENCIA]: 24,
        [TipoExperienciaEnum.NO_DOCENCIA]: 0,
    },
};

// Calculo de experiencias requeridas

/**
* Interfaz para los objetos de experiencia profesional
*/
interface Experiencia {
    tipo: string;
    nombreEmpresaInstitucion: string;
    fechaInicio: string;
    fechaFin: string;
    nombreJefeInmediato: string;
    telefonoJefeInmediato: string;
    soporteId: string;
}

/**
 * Interfaz para representar un intervalo de tiempo
 */
interface Intervalo {
    inicio: Date;
    fin: Date;
}

/**
 * Calcula el número total de meses acumulados para cada tipo de experiencia,
 * evitando contar dos veces los periodos que se solapan.
 * 
 * @param experiencias - Array de objetos de experiencia profesional
 * @returns Un objeto con el total de meses por tipo de experiencia
 */
export function calcularMesesExperiencia(experiencias: ExperienciaLaboralItemForm[]): Record<string, number> {
    // Agrupar experiencias por tipo
    const experienciasPorTipo: Record<string, Intervalo[]> = {};

    // Separar las experiencias por tipo
    experiencias.forEach(exp => {
        if (!experienciasPorTipo[exp.tipo]) {
            experienciasPorTipo[exp.tipo] = [];
        }

        // Convertir fechas de string a objetos Date
        const fechaInicio = new Date(exp.fechaInicio);
        const fechaFin = new Date(exp.fechaFin);

        experienciasPorTipo[exp.tipo].push({
            inicio: fechaInicio,
            fin: fechaFin
        });
    });

    // Calcular meses totales para cada tipo
    const mesesPorTipo: Record<string, number> = {};

    for (const tipo in experienciasPorTipo) {
        const experienciasTipo = experienciasPorTipo[tipo];

        // Ordenar experiencias por fecha de inicio
        experienciasTipo.sort((a, b) => a.inicio.getTime() - b.inicio.getTime());

        // Unir intervalos que se solapan
        const intervalosUnidos = unirIntervalos(experienciasTipo);

        // Calcular el total de meses para los intervalos unidos
        let totalMeses = 0;
        intervalosUnidos.forEach(intervalo => {
            totalMeses += calcularMesesEntreFechas(intervalo.inicio, intervalo.fin);
        });

        mesesPorTipo[tipo] = totalMeses;
    }

    return mesesPorTipo;
}

/**
 * Une intervalos de tiempo que se solapan en una lista de intervalos
 * 
 * @param intervalos - Array de objetos con propiedades inicio y fin
 * @returns Array de intervalos unidos
 */
function unirIntervalos(intervalos: Intervalo[]): Intervalo[] {
    if (intervalos.length === 0) return [];

    const resultado: Intervalo[] = [{ ...intervalos[0] }];

    for (let i = 1; i < intervalos.length; i++) {
        const actual = intervalos[i];
        const ultimo = resultado[resultado.length - 1];

        // Si hay solapamiento
        if (actual.inicio <= ultimo.fin) {
            // Tomar la fecha de fin más tardía
            ultimo.fin = new Date(Math.max(ultimo.fin.getTime(), actual.fin.getTime()));
        } else {
            // No hay solapamiento, añadir nuevo intervalo
            resultado.push({ ...actual });
        }
    }

    return resultado;
}

/**
 * Calcula el número de meses entre dos fechas
 * 
 * @param fechaInicio - Fecha de inicio
 * @param fechaFin - Fecha de fin
 * @returns Número de meses entre las fechas
 */
function calcularMesesEntreFechas(fechaInicio: Date, fechaFin: Date): number {
    // Calcular años de diferencia
    const años = fechaFin.getFullYear() - fechaInicio.getFullYear();

    // Calcular meses de diferencia
    let meses = fechaFin.getMonth() - fechaInicio.getMonth();

    // Ajustar por años
    meses += años * 12;

    // Ajustar por días (si la fecha de fin es antes del mismo día del mes de inicio)
    if (fechaFin.getDate() < fechaInicio.getDate()) {
        meses--;
    }

    // Si las fechas son el mismo mes y año, asegurarse de contar al menos 1 mes
    if (meses === 0 && fechaFin >= fechaInicio) {
        meses = 1;
    }

    return Math.max(0, meses);
}


// Validacion de experiencia
/**
 * Interfaz para el resultado de la validación
 */
interface ResultadoValidacion {
    cumple: boolean;
    mensaje: string;
    detalles?: {
      tipoExperiencia: string;
      mesesRequeridos: number;
      mesesAcumulados: number;
      cumple: boolean;
    }[];
  }
  
/**
 * Verifica si el perfil existe en la matriz de requisitos
 * 
 * @param perfilId - ID del perfil a validar
 * @returns Resultado con mensajes de error si el perfil no existe
 */
function verificarPerfilExiste(perfilId: PerfilesId): ResultadoValidacion | null {
  if (!ExperienciasRequeridas[perfilId]) {
    return {
      cumple: false,
      mensaje: `El perfil ${perfilId} no existe en la matriz de experiencias requeridas.`
    };
  }
  return null;
}

/**
 * Valida la experiencia de docencia
 * 
 * @param mesesDocencia - Meses acumulados de docencia
 * @param requisitoDocencia - Meses requeridos de docencia
 * @returns Objeto con detalles de validación y meses excedentes
 */
function validarExperienciaDocencia(mesesDocencia: number, requisitoDocencia: number) {
  const cumpleDocencia = mesesDocencia >= requisitoDocencia;
  const detalle = {
    tipoExperiencia: TipoExperienciaEnum.DOCENCIA,
    mesesRequeridos: requisitoDocencia,
    mesesAcumulados: mesesDocencia,
    cumple: cumpleDocencia
  };
  
  const mesesExcedentesDocencia = cumpleDocencia ? mesesDocencia - requisitoDocencia : 0;
  
  return { detalle, cumpleDocencia, mesesExcedentesDocencia };
}

/**
 * Valida la experiencia no docente
 * 
 * @param mesesNoDocencia - Meses acumulados de experiencia no docente
 * @param requisitoNoDocencia - Meses requeridos de experiencia no docente
 * @param mesesExcedentesDocencia - Meses excedentes de docencia que pueden aplicarse
 * @returns Objeto con detalles de validación
 */
function validarExperienciaNoDocente(mesesNoDocencia: number, requisitoNoDocencia: number, mesesExcedentesDocencia: number) {
  // Si no se requiere experiencia no docente
  if (requisitoNoDocencia <= 0) {
    return { detalle: null, cumpleNoDocencia: true };
  }
  
  // Calcular meses efectivos de no docencia, sumando el tiempo excedente de docencia
  const mesesEfectivosNoDocencia = mesesNoDocencia + mesesExcedentesDocencia;
  const cumpleNoDocencia = mesesEfectivosNoDocencia >= requisitoNoDocencia;
  
  const detalle = {
    tipoExperiencia: TipoExperienciaEnum.NO_DOCENCIA,
    mesesRequeridos: requisitoNoDocencia,
    mesesAcumulados: mesesNoDocencia,
    mesesAdicionales: mesesExcedentesDocencia > 0 ? mesesExcedentesDocencia : 0,
    mesesEfectivos: mesesEfectivosNoDocencia,
    cumple: cumpleNoDocencia
  };
  
  return { detalle, cumpleNoDocencia };
}

/**
 * Construye el mensaje de resultado
 * 
 * @param cumpleTodos - Si cumple con todos los requisitos
 * @param perfilId - ID del perfil validado
 * @param detallesValidacion - Array con detalles de validación
 * @returns Mensaje descriptivo del resultado
 */
function construirMensajeResultado(cumpleTodos: boolean, perfilId: PerfilesId, detallesValidacion: any[]): string {
  if (cumpleTodos) {
    return `El perfil ${perfilId} cumple con todos los requisitos de experiencia mínima.`;
  }
  
  let faltantes = '';
  
  // Verificar si falta experiencia docente
  if (!detallesValidacion[0].cumple) {
    faltantes += `Docencia: se requieren ${detallesValidacion[0].mesesRequeridos} meses, pero solo tiene ${detallesValidacion[0].mesesAcumulados} meses acumulados\n `;
  }
  
  // Verificar si falta experiencia no docente
  if (detallesValidacion.length > 1 && !detallesValidacion[1].cumple) {
    const detalle = detallesValidacion[1];
    faltantes += `Experiencia empresarial o en la industria: se requieren ${detalle.mesesRequeridos} meses, ` +
      `tiene ${detalle.mesesAcumulados} meses acumulados`;
    
    if ((detalle.mesesAdicionales ?? 0) > 0) {
      faltantes += ` y se consideraron ${detalle.mesesAdicionales} meses adicionales de docencia ` +
        `(total efectivo: ${detalle.mesesEfectivos} meses)`;
    }
  }
  
  return `\n ${faltantes}.`;
}

/**
 * Valida si un perfil cumple con la experiencia mínima requerida
 * Permite usar tiempo adicional de docencia para suplir experiencia no docente
 * 
 * @param perfilId - ID del perfil a validar
 * @param experienciaCalculada - Objeto con los meses acumulados por tipo de experiencia
 * @returns Resultado de la validación con detalle de cumplimiento
 */
export function validarExperienciaMinima(
  perfilId: PerfilesId,
  experienciaCalculada: Record<string, number>
): ResultadoValidacion {
  // Verificar si el perfil existe
  const perfilInvalido = verificarPerfilExiste(perfilId);
  if (perfilInvalido) return perfilInvalido;
  
  const requisitos = ExperienciasRequeridas[perfilId];
  const detalles = [];
  
  // Obtener la experiencia acumulada de cada tipo
  const mesesDocencia = experienciaCalculada[TipoExperienciaEnum.DOCENCIA] || 0;
  const mesesNoDocencia = experienciaCalculada[TipoExperienciaEnum.NO_DOCENCIA] || 0;
  
  // Meses requeridos de cada tipo
  const requisitoDocencia = requisitos[TipoExperienciaEnum.DOCENCIA] || 0;
  const requisitoNoDocencia = requisitos[TipoExperienciaEnum.NO_DOCENCIA] || 0;
  
  // Validar experiencia de docencia
  const validacionDocencia = validarExperienciaDocencia(mesesDocencia, requisitoDocencia);
  detalles.push(validacionDocencia.detalle);
  
  // Validar experiencia no docente
  const validacionNoDocencia = validarExperienciaNoDocente(
    mesesNoDocencia, 
    requisitoNoDocencia, 
    validacionDocencia.mesesExcedentesDocencia
  );
  
  if (validacionNoDocencia.detalle) {
    detalles.push(validacionNoDocencia.detalle);
  }
  
  // Determinar si cumple con todos los requisitos
  const cumpleTodos = validacionDocencia.cumpleDocencia && validacionNoDocencia.cumpleNoDocencia;
  
  // Construir mensaje de resultado
  const mensaje = construirMensajeResultado(cumpleTodos, perfilId, detalles);

  return {
    cumple: cumpleTodos,
    mensaje,
    detalles
  };
}